import client from "./client";

export const statCurvesApi = {
  // Admin — families
  adminList:         ()               => client.get("/admin/stat_curves"),
  adminCreate:       (data)           => client.post("/admin/stat_curves", data),
  adminUpdate:       (id, data)       => client.patch(`/admin/stat_curves/${id}`, data),
  adminDelete:       (id)             => client.delete(`/admin/stat_curves/${id}`),

  // Admin — curve points (upsert full point list for a variant)
  adminSaveCurve:    (familyId, variant, points) =>
    client.put(`/admin/stat_curves/${familyId}/curves/${variant}`, { points }),

  // Public — read all families with curves
  list:              ()               => client.get("/stat_curves"),

  // Public — interpolate
  interpolate:       (name, x, variant = "standard") =>
    client.get(`/stat_curves/${name}/interpolate`, { params: { x, variant } }),
};
